module.exports = __webpack_public_path__ + "static/nipcbestfriends3-a63066eecd37ca00dcbf010dd8ba25d9.jpeg";